import axios from '@/utils/fetch';
import { $error } from '@/pages/v2/search/util';

const editorial = {
  searchHot: '/api/search/hot',
  searchUpload: '/api/search/upload',
  searchUploadUrl: '/api/search/uploadurl',
  searchDownload: '/api/search/download',
  shopCardCount: '/api/shoppingcart/count',
  categoryTag: '/api/category/tag',
  userInfo: '/api/user/info',
  token: '/api/xsrftoken',
  logout: '/api/account/logout',
  categoryList: '/api/category/list',
  categoryTagV2: '/api/editorial/categoryTag',
  gallery: '/api/category',
  categoryLatest: '/api/category/latest',
  categoryLatestTopic: '/api/category/latest/topic',
  realtimehots: '/api/thermal/list',
  currentHotTopic: '/api/editorial/hotTopicGet',
};

export function getXSRFToken(): Promise<any> {
  return axios.get(editorial.token);
}

export function getHotRecommend(): Promise<any> {
  return axios.get(editorial.searchHot);
}

export function getCategoryList(): Promise<any> {
  return axios.get(editorial.categoryList);
}

export function getUserInfo(token: string): Promise<any> {
  return axios.get(editorial.userInfo, {
    params: {
      xsrfToken: token,
    },
  });
}

export function getShopCardCount(): Promise<any> {
  return axios.get(editorial.shopCardCount);
}

export function getGallery(categoryId: string): Promise<any> {
  return axios.get(editorial.gallery, {
    params: {
      categoryId,
    },
  });
}

export async function uploadImage(file: File | string): Promise<any> {
  try {
    const isString = typeof file === 'string';
    const data = isString ? { url: file } : { image: file };

    const result: any = await axios.post(
      isString ? editorial.searchUploadUrl : editorial.searchUpload,
      data,
    );
    if (result?.errno && result?.errno !== 0) {
      $error(result?.errmsg);
      return null;
    } else {
      return result;
    }
  } catch (error: any) {
    if (error?.errno && error?.errno !== 0) {
      $error(error?.errmsg);
    } else {
      $error('网络错误，请重试');
    }
    return null;
  }
}

export function searchDownload(imageId: string): Promise<any> {
  return axios.post(
    editorial.searchDownload,
    { imageId },
    { responseType: 'blob', unwrap: false },
  );
}

export function getCategoryTag(params: any): Promise<any> {
  return axios.get(editorial.categoryTag, {
    params,
  });
}

export function getCategoryTagLatestTopic(params: any): Promise<any> {
  return axios.get(editorial.categoryLatestTopic, {
    params,
  });
}

export function getCategoryTagLatest(params: any): Promise<any> {
  return axios.get(editorial.categoryLatest, {
    params,
  });
}

export function getCagetoryTagV2(): Promise<any> {
  return axios.get(editorial.categoryTagV2);
}

export function logout(): Promise<any> {
  return axios.post(editorial.logout);
}

export function getrealtimehots(params: any): Promise<any> {
  return axios.get(editorial.realtimehots, {
    params,
  });
}

export function getSportsCategoryTag(params: any): Promise<any> {
  return axios.get(editorial.gallery, {
    params,
  });
}

export function getSportsCategoryList(params: any): Promise<any> {
  return axios.get(editorial.categoryLatest, {
    params,
  });
}

/**
 * 获取编辑页面当前热点
 * @returns
 */
export function getCurrentHotTopic(): Promise<any> {
  return axios.get(editorial.currentHotTopic);
}
